import { Component } from '@angular/core';

@Component({
  selector: 'app-oilgas',
  templateUrl: './oilgas.component.html',
  styleUrl: './oilgas.component.scss'
})
export class OilgasComponent {

}
